// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__26vz9","togglePause":"style_togglePause__1q7d8"};